import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, Platform, TextInput } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, aboutAuthor, pageContent, input, Colors, bannerStyles, Messages, FontFamily, FontWeight, button, Typo, appHeader } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';

import getImagePath from '../../utils/image-helper';
import { helpers } from '../../utils/helpers';


export class GeneralNotificationBand extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationText: this.props.notificationText,
            redirectionPath: this.props.redirectionPath,
            ctaText: this.props.ctaText,
            bgColor: this.props.backgroundColor,
            btnDisable: true,
            email: '',
            referralMsg: {
                enable: false,
                type: '', // error / success
                msg: ''
            },
        }
    }

    componentDidMount = () => {

    }

    render() {
        let { notificationText, redirectionPath, ctaText, bgColor } = this.state;
        let webView = helpers.isWeb();
        let { darkMode } = this.props;

        let btnClick;
        if (webView) {
            btnClick = {
                to: redirectionPath
            }
        } else {
            btnClick = {
                onPress: () => this.props.navigateApp(redirectionPath)
            }
        }

        return (
            <View style={{ marginBottom: '5px', backgroundColor: bgColor, marginTop: helpers.isDesktop() ? -10 : 0, paddingVertical: helpers.isDesktop() ? 10 : 10, flexDirection: helpers.isDesktop() ? 'row' : 'column', alignItems: 'center' }}>
                <View style={{ marginLeft: 'auto', marginRight: helpers.isDesktop() ? 10 : 'auto' }}>
                    <Text
                        style={[
                            Helpers.textCenter,
                            helpers.isDesktop() && Typo.h3_RDesktop,
                            !helpers.isDesktop() && { paddingHorizontal: 10 },
                            Margin.mb_0,
                            { color: "#fff" },
                            { fontSize: helpers.isDesktop() ? 20 : 12 },
                            !helpers.isWeb() && { marginBottom: 1 },
                            darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                    >
                        {notificationText}
                    </Text>
                </View>
                {helpers.isDesktop() ?
                    <View style={{ marginRight: 'auto' }}>
                        <TouchableOpacityLink {...btnClick}>
                            <Text
                                style={[
                                    Helpers.textUppercase,
                                    {
                                        color: "#907CFF",
                                        fontSize: 15,
                                        fontFamily: FontFamily.regular,
                                        fontWeight: '600',
                                        whiteSpace: "nowrap",
                                        backgroundColor: '#fff',
                                        // borderWidth: 1,
                                        // borderColor: "#907CFF",
                                        paddingHorizontal: helpers.isDesktop() ? 10 : 20,
                                        paddingVertical: helpers.isDesktop() ? 5 : 10,
                                    },
                                ]}
                            >
                                {ctaText}
                            </Text>
                        </TouchableOpacityLink>
                    </View>
                    :
                    <View style={{ marginVertical: 10, marginHorizontal: 'auto' }}>
                        <TouchableOpacityLink {...btnClick}>
                            <Text
                                style={[
                                    Helpers.textUppercase,
                                    {
                                        color: "#907CFF",
                                        fontSize: 10,
                                        fontFamily: FontFamily.medium,
                                        fontWeight: FontWeight.regular,
                                        whiteSpace: "nowrap",
                                        backgroundColor: '#fff',
                                        borderWidth: 1,
                                        borderColor: "#907CFF",
                                        paddingHorizontal: 20,
                                        paddingVertical: 10,
                                    },
                                ]}
                            >
                                {ctaText}
                            </Text>
                        </TouchableOpacityLink>
                    </View>
                }
            </View >
        );
    }
}

export default GeneralNotificationBand;